<template>
	<div class="comp">
		<el-dialog :title="'打印预览'" :visible.sync="dialogState" width="800px" top="5vh">
			<div v-if="detail.caseNumber&&detail.inspectItem">
				<div class="label">检测</div>
				<el-table class="table" :data="detail.inspectItem.filter(item=>{return item.isPay})" ref="table1" style="width: 100%">
					<el-table-column prop="goodsName" label="名称" >
					</el-table-column>
					<el-table-column prop="otherName" label="打印名称" >
						<template slot-scope="props">
							<el-input v-model="props.row.otherName"></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="skuValue" label="规格" width="120">
					</el-table-column>
					<el-table-column prop="num" label="用量" width="80">
					</el-table-column>
					<el-table-column prop="originalPrice" label="用量单位" width="100">
					</el-table-column>
				</el-table>
			</div>
			<div v-if="detail.caseNumber&&detail.recipelItem">
				<div class="label">处方</div>
				<el-table class="table" :data="detail.recipelItem.filter(item=>{return item.isPay})" ref="table2" style="width: 100%">
					<el-table-column prop="goodsName" label="名称" >
					</el-table-column>
					<el-table-column prop="otherName" label="打印名称" >
						<template slot-scope="props">
							<el-input v-model="props.row.otherName"></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="skuValue" label="规格" width="120">
					</el-table-column>
					<el-table-column prop="num" label="用量" width="80">
					</el-table-column>
					<el-table-column prop="originalPrice" label="用量单位" width="100">
					</el-table-column>
				</el-table>
			</div>
			<div v-if="detail.caseNumber&&detail.handleItem">
				<div class="label">处置</div>
				<el-table class="table" :data="detail.handleItem.filter(item=>{return item.isPay})" ref="table3" style="width: 100%">
					<el-table-column prop="goodsName" label="名称" >
					</el-table-column>
					<el-table-column prop="otherName" label="打印名称" >
						<template slot-scope="props">
							<el-input v-model="props.row.otherName"></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="skuValue" label="规格" width="120">
					</el-table-column>
					<el-table-column prop="num" label="用量" width="80">
					</el-table-column>
					<el-table-column prop="originalPrice" label="用量单位" width="100">
					</el-table-column>
				</el-table>
			</div>
			<div v-if="detail.caseNumber&&detail.operationItem">
				<div class="label">手术</div>
				<el-table class="table" :data="detail.operationItem.filter(item=>{return item.isPay})" ref="table4" style="width: 100%">
					<el-table-column prop="goodsName" label="名称" >
					</el-table-column>
					<el-table-column prop="otherName" label="打印名称" >
						<template slot-scope="props">
							<el-input v-model="props.row.otherName"></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="skuValue" label="规格" width="120">
					</el-table-column>
					<el-table-column prop="num" label="用量" width="80">
					</el-table-column>
					<el-table-column prop="originalPrice" label="用量单位" width="100">
					</el-table-column>
				</el-table>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submit">立 即 打 印</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import axios from 'axios';
	export default {
		data() {
			return {
				dialogState:true,
				detail:{},
			}
		},
		props:{
			bingliObj:{
				default:()=>{
					return {}
				}
			}
		},
		watch:{
			dialogState(){
				this.$emit('submit',{type:'close',data:''})
			}
		},
		mounted() {
			this.detail = JSON.parse(JSON.stringify(this.bingliObj))
		},
		methods: {
			submit(){
				let inspectItem = []
				for(let i=0;i<this.detail.inspectItem.length;i++){
					inspectItem.push({
						"otherName": this.detail.inspectItem[i].otherName,
						"skuName": this.detail.inspectItem[i].skuValue,
						"outDosage": this.detail.inspectItem[i].goodsDosage,
						"outUnit": this.detail.inspectItem[i].outUnit,
					})
				}
				let recipelItem = []
				for(let i=0;i<this.detail.recipelItem.length;i++){
					recipelItem.push({
						"otherName": this.detail.recipelItem[i].otherName,
						"skuName": this.detail.recipelItem[i].skuValue,
						"outDosage": this.detail.recipelItem[i].goodsDosage,
						"outUnit": this.detail.recipelItem[i].outUnit,
					})
				}
				let handleItem = []
				for(let i=0;i<this.detail.handleItem.length;i++){
					handleItem.push({
						"otherName": this.detail.handleItem[i].otherName,
						"skuName": this.detail.handleItem[i].skuValue,
						"outDosage": this.detail.handleItem[i].goodsDosage,
						"outUnit": this.detail.handleItem[i].outUnit,
					})
				}
				let operationItem = []
				for(let i=0;i<this.detail.operationItem.length;i++){
					operationItem.push({
						"otherName": this.detail.operationItem[i].otherName,
						"skuName": this.detail.operationItem[i].skuValue,
						"outDosage": this.detail.operationItem[i].goodsDosage,
						"outUnit": this.detail.operationItem[i].outUnit,
					})
				}
				let params = {
					"caseNumber": this.detail.caseNumber,
					"inspectItem": inspectItem,
					"recipelItem": recipelItem,
					"handleItem": handleItem,
					"operationItem":operationItem,
				}
				let loading = this.$loading();
				axios({
					method:"post",
					url:'/api/Case/PrintCase',
					data:params,
					responseType: 'blob'
				}).then(res => {
					let blob = new Blob([res.data],{
						type:"application/pdf"
					})
					var href = window.URL.createObjectURL(blob); //创建下载的链接
					var downloadElement = document.createElement('a');
					downloadElement.href = href;
					downloadElement.download = this.detail.caseNumber+'.pdf';
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放掉blob对象
					loading.close();
					this.$emit('submit',{type:'success',data:''})
				})
			}
		}
	}
</script>
<style lang="scss" scoped>
	.comp {
		.label{
			font-size: 14px;font-weight: bold;padding:20px 0 5px;
		}
		::v-deep.el-dialog__body{
			padding-top:10px;
		}
	}
</style>
